// Vendors
import React, { useRef } from 'react';
import { CSSTransition } from 'react-transition-group';
import classnames from 'classnames';

// Styles
import './grow-transition.scss';

const GrowTransition = ({ className, children, ...props }) => {
  const nodeRef = useRef(null);

  return (
    <CSSTransition
      {...props}
      nodeRef={nodeRef}
      classNames="grow-transition"
      timeout={300}
      unmountOnExit
    >
      <div ref={nodeRef} className={classnames('grow-transition', className)}>{children}</div>
    </CSSTransition>
  );
};

export default GrowTransition;
